import { http } from 'services/http';
import { CLIENT_GET_ONE, CLIENTS_GET_MANY } from 'api/query-keys.ts';
import type { ClientRes, TBlockClientReq } from 'api/swagger';
import { useMutationBase } from 'shared/hooks/use-mutation-base.ts';

export const useSetBlockClient = (clientId: number) => {
  return useMutationBase<ClientRes, unknown, TBlockClientReq>({
    mutationFn: async (variables) => {
      const res = await http.patch<ClientRes>(`/v1/clients/${clientId}/block`, variables);

      return res.data;
    },

    invalidateCallback: ({ id }) => [[CLIENT_GET_ONE, id], [CLIENTS_GET_MANY]],
  });
};
